import styled from 'styled-components';
import { TypographyStyles, colours, media } from '@storefront/lib-global';

export const StyledErrorMessage = styled.span`
  ${TypographyStyles.Body.Small.Medium}
  color: ${colours.ERROR_PRIMARY};

  @media ${media.greaterThan('lg')} {
    font-size: 14px;
    line-height: 24px;
  }
`;
